/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminImpersonateCodeExchangeResponse
 */
export interface AdminImpersonateCodeExchangeResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminImpersonateCodeExchangeResponse
     */
    accessToken: string;
    /**
     * 
     * @type {string}
     * @memberof AdminImpersonateCodeExchangeResponse
     */
    refreshToken: string;
    /**
     * 
     * @type {string}
     * @memberof AdminImpersonateCodeExchangeResponse
     */
    idToken: string;
    /**
     * 
     * @type {number}
     * @memberof AdminImpersonateCodeExchangeResponse
     */
    expiresIn: number;
    /**
     * 
     * @type {string}
     * @memberof AdminImpersonateCodeExchangeResponse
     */
    tokenType: string;
}

/**
 * Check if a given object implements the AdminImpersonateCodeExchangeResponse interface.
 */
export function instanceOfAdminImpersonateCodeExchangeResponse(value: object): value is AdminImpersonateCodeExchangeResponse {
    if (!('accessToken' in value) || value['accessToken'] === undefined) return false;
    if (!('refreshToken' in value) || value['refreshToken'] === undefined) return false;
    if (!('idToken' in value) || value['idToken'] === undefined) return false;
    if (!('expiresIn' in value) || value['expiresIn'] === undefined) return false;
    if (!('tokenType' in value) || value['tokenType'] === undefined) return false;
    return true;
}

export function AdminImpersonateCodeExchangeResponseFromJSON(json: any): AdminImpersonateCodeExchangeResponse {
    return AdminImpersonateCodeExchangeResponseFromJSONTyped(json, false);
}

export function AdminImpersonateCodeExchangeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminImpersonateCodeExchangeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'accessToken': json['accessToken'],
        'refreshToken': json['refreshToken'],
        'idToken': json['idToken'],
        'expiresIn': json['expiresIn'],
        'tokenType': json['tokenType'],
    };
}

export function AdminImpersonateCodeExchangeResponseToJSON(json: any): AdminImpersonateCodeExchangeResponse {
    return AdminImpersonateCodeExchangeResponseToJSONTyped(json, false);
}

export function AdminImpersonateCodeExchangeResponseToJSONTyped(value?: AdminImpersonateCodeExchangeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accessToken': value['accessToken'],
        'refreshToken': value['refreshToken'],
        'idToken': value['idToken'],
        'expiresIn': value['expiresIn'],
        'tokenType': value['tokenType'],
    };
}

